export const paginationOptions: number[] = [25, 50, 100, 1000]
